import { ReactNode } from 'react'
import { Column } from 'src/shared/components/Semantic/all'
import { Card } from 'src/shared/components/ui/card'
import { cn } from 'src/shared/components/ui/utils'
import { IconCard } from './IconCard'
import { Image } from './ui'

interface EmptyStateProps {
  /** Icon element to display in the empty state (e.g., <Plus className="w-4 h-4" />) */
  icon?: ReactNode
  /** Icon color variant */
  iconColor?: 'default' | 'green' | 'blue' | 'red' | 'orange'
  /** Image to display in the empty state (e.g., <Image src="path/to/image.png" alt="Empty state image" />) */
  image?: string
  /** Title text */
  title: string
  /** Description text */
  description?: string
  /** Standalone action element rendered below the description (e.g., <Button>...</Button>) */
  button?: ReactNode
  /** Whether to wrap in a Card component */
  withCard?: boolean
  /** Additional className for the container */
  className?: string
  /** Additional className for the card */
  cardClassName?: string
}

export const EmptyState = ({
  icon: Icon,
  image,
  iconColor = 'default',
  title,
  description,
  button,
  withCard = true,
  className,
  cardClassName,
}: EmptyStateProps) => {
  console.log(image)
  const content = (
    <Column
      className={cn(
        'items-center justify-center gap-4 text-center',
        !withCard && 'py-12 px-4',
        className
      )}
    >
      {!image && Icon && <IconCard Icon={Icon} color={iconColor} size="lg" />}
      {image && (
        <Image
          src={image}
          className="h-48 w-auto border border-gray-200 rounded-lg rotate-[10deg] mb-2"
          alt="Empty state image"
        />
      )}
      <Column className="gap-2">
        <h2 className="text-gray-900">{title}</h2>
        {description && (
          <p className="text-sm text-gray-600 max-w-md">{description}</p>
        )}
      </Column>

      {button}
    </Column>
  )

  if (withCard) {
    return <Card className={cn('p-12', cardClassName)}>{content}</Card>
  }

  return content
}
